import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M14 19a6 6 0 0 0-12 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "9", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 11 18 13 22 9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UserCheck2";
const UserCheck2 = memo(themed(Icon));
export {
  UserCheck2
};
//# sourceMappingURL=user-check-2.js.map
